import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import ChangePassword from 'components/user/profile/modal/password_change';

const ChangePasswordButton = ({ user, refetch }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();

  return (
    <Button
      variant="outlined"
      color="secondary"
      onClick={() =>
        addModal(
          <ChangePassword
            user={user}
            onSuccess={() => {
              refetch();
              removeModal();
              setInfo('info.user.profile.password.changed');
            }}
            handleClose={() => {
              removeModal();
            }}
          />,
          { disableAutoFocus: true, disableRestoreFocus: true }
        )
      }
    >
      <FormattedMessage id="button.change_password" />
    </Button>
  );
};

export default ChangePasswordButton;
